<template>
  <span
    :style="{ 'font-size': upperFontSize }">
    {{ prefix }}{{ upperMoney }}.<span
      :style="{ 'font-size': lowerFontSize, 'color': 'gray' }">{{ lowerMoney }}</span>
  </span>
</template>

<script>
export default {
  props: {
    number: {
      type: [Number, String],
      required: true,
    },
    upperFontSize: {
      type: String,
      default: '1.8rem',
    },
    lowerFontSize: {
      type: String,
      default: '0.8em',
    },
    prefix: {
      type: String,
      default: '¥',
    },
  },
  computed: {
    upperMoney() {
      return this.number
        ? new Intl.NumberFormat('ja-JP').format(Math.floor(this.number))
        : 0
    },
    lowerMoney() {
      const lowerNumber = this.number
        ? new Intl.NumberFormat('ja-JP', { minimumFractionDigits: 2 }).format(this.number).split('.')[1]
        : 0
      return (`00${lowerNumber}`).slice(-2)
    },
  },
}
</script>
